// EditLeadForm.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import LeadForm from './LeadForm';


const EditLeadForm = () => {
    const location = useLocation();
    const leadData = location.state?.leadData; // Get lead data passed through navigation


    return <LeadForm isEditMode={true} initialData={leadData} pathName={'editForm'}/>;
};

export default EditLeadForm;